import { getType, Instance, isStateTreeNode } from 'mobx-state-tree'
import { Survey } from '../models/Survey'

export const isSurvey = (value: any): value is Instance<typeof Survey> => {
  return isStateTreeNode(value) && getType(value).name === 'Survey'
}
